module.exports = __webpack_public_path__ + "img/logoecharts.7d97d163.png";